export default "__VITE_ASSET__Dv4jJxxb__"